import React from "react";

export const Header = () => {
    return(
        <header className="header">
        <h1 className="title">Happy thoughts</h1>
        </header>
    )
}